import { ref } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import TourManager from '@/Services/TourManager';

function useTourManager(tourName, steps, options = {}) {
  const tourManager = ref(new TourManager(tourName, steps, options));

  const startTour = () => {
    tourManager.value.startTour();
  };

  const cancelTour = () => {
    tourManager.value.cancelTour();
  };

  Inertia.on('navigate', () => {
    setTimeout(() => {
      tourManager.value.cancelTour();
    }, 0);
  });
  return { startTour, cancelTour };
}

export default useTourManager;
